import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";

export default class HighlightTextArrayBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.highlightTextArray = {
            update: (element: HTMLElement, valueAccessor: () => any) => {
                let value = valueAccessor();
                let text = value.text;
                if (ko.isObservable(text)) {
                    text = text();
                }
                let words = value.keywords;

                if (value.keywords.length > 0) {
                    // entferne HTML-Tags
                    text = $("<div>" + text + "</div>").text();
                    let span = $('<span>' + text + '</span>');

                    words.sort((a, b) => {
                        return b.length - a.length; // ASC -> a - b; DESC -> b - a
                    });

                    for (const word of words) {
                        ($(span) as any).highlight(word);
                    }
                    $(element).html($(span).html());
                }
                else {
                    $(element).text(text);
                }
            }
        };
    }
}